import React from 'react';
import './DeviceManage.less';
import {
  Button,
  Input,
  InputNumber,
  Modal,
  Select,
  Switch,
  Table,
  Tabs
} from 'antd';
import { MEETING_STATUS } from '../../utils/constants';
import { Btn, OperateSpan } from '../../components/Widgets';
import IconTip from '../../components/IconTip';
import { FormattedMessage, injectIntl } from 'react-intl';

const TabPane = Tabs.TabPane;
const Option = Select.Option;
const STABLE_TAB = '1';
const MOBILE_TAB = '2';

const DefaultMobile = {
  id: 0,
  name: '',
  remark: '',
  number: 0,
  zoneId: '',
  type: 2
};

const DefaultStable = {
  id: 0,
  name: '',
  nameEn: '',
  type: 0
};

//会议室服务管理
class DeviceManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isBorrow: false,
      activeKey: STABLE_TAB,
      deviceInfo: { ...DefaultMobile },
      stableInfo: { ...DefaultStable },
      floorData: [],
      zoneId: '',
      parkId: ''
    };
  }

  render() {
    const { activeKey, isBorrow } = this.state;
    const { deviceModal, intl, lendDevice } = this.props;
    let mobileTitle = <FormattedMessage id="device_manage_add_mobile" />;
    if (this.state.deviceInfo.id && this.state.deviceInfo.id > 0) {
      mobileTitle = <FormattedMessage id="device_manage_edit_mobile" />;
    }
    let stableTitle = <FormattedMessage id="device_manage_add_stable" />;
    if (this.state.stableInfo.id && this.state.stableInfo.id > 0) {
      stableTitle = <FormattedMessage id="device_manage_edit_stable" />;
    }

    let lendCnt = 0;
    lendDevice &&
    lendDevice.list &&
    lendDevice.list.filter(m=>m.status===MEETING_STATUS.pending).forEach(m=>{
      m.deviceList && m.deviceList.forEach(d=>{
        if (d.lendState === 0) {
          lendCnt ++
        }
      })
    });

    return (
      <div className="device-container">
        {
          isBorrow ?
          <div>
            <div className="borrow-title">
              <FormattedMessage id="device_manage_borrow_manage" />
            </div>
            {this.gradeTab()}
          </div> :
          <Tabs
            type="card"
            activeKey={activeKey}
            onChange={activeKey => this.setState({ activeKey: activeKey })}
          >
            <TabPane
              key={STABLE_TAB}
              tab={intl.formatMessage({ id: 'device_manage_stable_manage' })}
            >
              {this.stableTab()}
            </TabPane>
            <TabPane
              key={MOBILE_TAB}
              tab={intl.formatMessage({ id: 'device_manage_mobile_manage' })}
            >
              {this.itemTab()}
            </TabPane>
          </Tabs>
        }
        <div className="device-btn-line">
          {
            !isBorrow &&
            activeKey === MOBILE_TAB &&
            <Button
              className="new-btn"
              type="ghost"
              onClick={() => {
                this.setState({isBorrow: true})
              }}
            >
              <FormattedMessage id="device_manage_borrow_manage" />
              {
                lendCnt > 0 &&
                <span style={{color:'red', marginLeft:'5px'}}>
                  {`(${lendCnt})`}
                </span>
              }
            </Button>
          }
          {
            !isBorrow &&
            <Button
              className="new-btn"
              type="primary"
              icon="plus"
              onClick={() => {
                this.setState({
                  deviceInfo: DefaultMobile,
                  stableInfo: DefaultStable,
                  zoneId: '',
                  parkId: '',
                  floorData: []
                });
                this.showModal({});
              }}
            >
              {
                activeKey === MOBILE_TAB ?
                <FormattedMessage id="device_manage_add_mobile" /> :
                <FormattedMessage id="device_manage_add_stable" />
              }
            </Button>
          }
          {
            isBorrow &&
            <Button
              className="new-btn"
              type="ghost"
              onClick={() => {
                this.setState({isBorrow: false})
              }}
            >
              <FormattedMessage id="device_manage_back" />
            </Button>
          }
        </div>
        <Modal
          wrapClassName="device-manage-wrapper modal-close-header"
          visible={deviceModal}
          title={activeKey === MOBILE_TAB ? mobileTitle : stableTitle}
          onCancel={() => this.closeModal()}
          footer={
            <div className="service-manage-footer">
              <Btn onClick={() => this.closeModal()}>
                <FormattedMessage id="device_manage_cancel" />
              </Btn>
              <Btn primary onClick={() => {
                const { bindRooms } = this.props;
                const { activeKey } = this.state;
                if (activeKey === MOBILE_TAB) {
                  this.submit()
                } else {
                  if (bindRooms !== '') {
                    const msgBody = [];
                    const pl35 = { paddingLeft: '35px' };
                    const rmNm = {
                      maxWidth: '90%',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis'
                    }
                    msgBody.push(<p style={pl35}>{intl.formatMessage({ id: 'device_manage_confirm_occupied'})}</p>);
                    msgBody.push(<p style={{...pl35, ...rmNm}}>{bindRooms}</p>);
                    msgBody.push(<p style={pl35}>{intl.formatMessage({ id: 'device_manage_confirm_if_update'})}</p>);
                    Modal.confirm({
                      content: msgBody,
                      onOk: () => {
                        this.submit()
                      },
                      onCancel: () => {
                        return
                      }
                    })
                  } else {
                    this.submit()
                  }
                }
              }}>
                <FormattedMessage id="device_manage_ok" />
              </Btn>
            </div>
          }
        >
          {activeKey === MOBILE_TAB && this.itemModal()}
          {activeKey === STABLE_TAB && this.stableModal()}
        </Modal>
      </div>
    );
  }

  gradeTab = () => {
    const { lendDevice, dispatch, intl } = this.props;
    const pagination = {
      onChange: (current, pageSize) => {
        dispatch({
          type: 'account/getLendList',
          payload: Object.assign({}, { current: current, pageSize: pageSize })
        });
      },
      current: lendDevice ? lendDevice.pageNo : 1,
      pageSize: lendDevice ? lendDevice.pageSize : 10,
      total: lendDevice ? lendDevice.total : 10
    };
    const gradeColumns = [
      {
        title: intl.formatMessage({ id: 'device_manage_meeting_time' }),
        dataIndex: 'showStartTime',
        key: 'showStartTime'
      },
      {
        title: intl.formatMessage({ id: 'device_manage_meeting_title' }),
        key: 'name',
        render: record => {
          return <span>{record.name}</span>;
        }
      },
      {
        title: intl.formatMessage({ id: 'device_manage_meeting_room' }),
        key: 'roomNames',
        width: 200,
        render: record => {
          return <span>{record.roomNames}</span>;
        }
      },
      {
        title: intl.formatMessage({ id: 'device_manage_meeting_applier' }),
        dataIndex: 'holder',
        key: 'holder'
      },
      {
        title: intl.formatMessage({ id: 'device_manage_meeting_device' }),
        key: 'deviceName',
        render: record => {
          return (
            <div className="separate_table_div">
              {record.deviceList &&
                record.deviceList.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="separate"
                      style={
                        index === record.deviceList.length - 1
                          ? { borderBottom: '0' }
                          : {}
                      }
                    >
                      {item.device.name}
                    </div>
                  );
                })}
            </div>
          );
        }
      },
      {
        title: intl.formatMessage({ id: 'device_manage_number' }),
        key: 'num',
        render: record => {
          return (
            <div className="separate_table_div">
              {record.deviceList &&
                record.deviceList.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="separate"
                      style={
                        index === record.deviceList.length - 1
                          ? { borderBottom: '0' }
                          : {}
                      }
                    >
                      {item.number}
                    </div>
                  );
                })}
            </div>
          );
        }
      },
      {
        title: intl.formatMessage({ id: 'device_manage_lend_state' }),
        key: 'lendState',
        render: record => {
          return (
            <div className="separate_table_div">
              {record.deviceList &&
                record.deviceList.map((item, index) => {
                  if (item.lendState === 0) {
                    if(record.status === MEETING_STATUS.closed ||
                      record.status === MEETING_STATUS.cancel){
                      return (
                        <div
                          key={index}
                          className="separate"
                          style={
                            index === record.deviceList.length - 1
                              ? { borderBottom: '0' }
                              : {}
                          }
                        >
                          <div
                            className="point"
                            style={{ backgroundColor: 'gray' }}
                          />
                          {
                            record.status === MEETING_STATUS.closed &&
                            <FormattedMessage id="meeting_status_2" />
                          }
                          {
                            record.status === MEETING_STATUS.cancel &&
                            <FormattedMessage id="meeting_status_3" />
                          }
                        </div>
                      );
                    } else {
                      return (
                        <div
                          key={index}
                          className="separate"
                          style={
                            index === record.deviceList.length - 1
                              ? { borderBottom: '0' }
                              : {}
                          }
                        >
                          <div
                            className="point"
                            style={{ backgroundColor: '#7DCD54' }}
                          />
                          <FormattedMessage id="device_manage_state_lend_able" />
                        </div>
                      );
                    }
                  } else if (item.lendState === 1) {
                    return (
                      <div
                        key={index}
                        className="separate"
                        style={
                          index === record.deviceList.length - 1
                            ? { borderBottom: '0' }
                            : {}
                        }
                      >
                        <div
                          className="point"
                          style={{ backgroundColor: '#FF3334' }}
                        />
                        <FormattedMessage id="device_manage_state_lending" />
                      </div>
                    );
                  } else if (item.lendState === 2) {
                    return (
                      <div
                        key={index}
                        className="separate"
                        style={
                          index === record.deviceList.length - 1
                            ? { borderBottom: '0' }
                            : {}
                        }
                      >
                        <div
                          className="point"
                          style={{ backgroundColor: 'gray' }}
                        />
                        <FormattedMessage id="device_manage_state_give_back" />
                      </div>
                    );
                  }
                })}
            </div>
          );
        }
      },
      {
        title: intl.formatMessage({ id: 'device_manage_operate' }),
        key: 'operation',
        render: record => {
          return (
            <div className="separate_table_div">
              {record.deviceList &&
                record.deviceList.map((item, index) => {
                  if (item.lendState === 0) {
                    if(record.status === MEETING_STATUS.closed ||
                      record.status === MEETING_STATUS.cancel){
                      return null;
                    }
                    return (
                      <div
                        key={index}
                        className="separate"
                        style={
                          index === record.deviceList.length - 1
                            ? { borderBottom: '0' }
                            : {}
                        }
                      >
                        <a
                          onClick={() => {
                            //更改为借用中
                            this.props.dispatch({
                              type: 'account/updateLendState',
                              payload: {
                                id: item.id,
                                lendState: 1,
                                current: pagination.current,
                                pageSize: pagination.pageSize
                              }
                            });
                          }}
                        >
                          <OperateSpan>
                            <IconTip
                              title={intl.formatMessage({
                                id: 'device_manage_lend'
                              })}
                              type="jiechu"
                            />
                          </OperateSpan>
                        </a>
                      </div>
                    );
                  } else if (item.lendState === 1) {
                    return (
                      <div
                        key={index}
                        className="separate"
                        style={
                          index === record.deviceList.length - 1
                            ? { borderBottom: '0' }
                            : {}
                        }
                      >
                        <a
                          onClick={() => {
                            this.props.dispatch({
                              type: 'account/updateLendState',
                              payload: {
                                id: item.id,
                                lendState: 2,
                                current: pagination.current,
                                pageSize: pagination.pageSize
                              }
                            });
                          }}
                        >
                          <OperateSpan>
                            <IconTip
                              title={intl.formatMessage({
                                id: 'device_manage_give_back'
                              })}
                              type="guihuan"
                            />
                          </OperateSpan>
                        </a>
                      </div>
                    );
                  } else if (item.lendState === 2) {
                    return (
                      <div
                        key={index}
                        className="separate"
                        style={
                          index === record.deviceList.length - 1
                            ? { borderBottom: '0' }
                            : {}
                        }
                      />
                    );
                  } else {
                  }
                })}
            </div>
          );
        }
      }
    ];
    return (
      <div className="grade-tab">
        <Table
          columns={gradeColumns}
          dataSource={lendDevice ? lendDevice.list : []}
          pagination={pagination}
          rowKey={r => r.id}
        />
      </div>
    );
  };

  itemTab = () => {
    const { deviceInfo = {}, allAreaDataNoPermission, intl } = this.props;
    const itemColumns = [
      {
        title: intl.formatMessage({ id: 'device_manage_device_name' }),
        dataIndex: 'name',
        width: '25%',
        key: 'name'
      },
      {
        title: intl.formatMessage({ id: 'device_manage_device_number' }),
        dataIndex: 'number',
        width: '8%',
        key: 'number'
      },
      {
        title: intl.formatMessage({ id: 'device_manage_device_describe' }),
        dataIndex: 'remark',
        width: '30%',
        key: 'remark'
      },
      {
        title: intl.formatMessage({ id: 'device_manage_floor' }),
        key: 'floor',
        render: record => {
          let zoneName = '';
          let parkId = '';
          if (record.zoneId) {
            allAreaDataNoPermission.child &&
              allAreaDataNoPermission.child.map(a => {
                if (a.child && a.child.some(c => c.id == record.zoneId)) {
                  zoneName = a.name;
                  parkId = a.id;
                }
              });
          }

          if (allAreaDataNoPermission && allAreaDataNoPermission.child) {
            let hasFindFloor = false;
            allAreaDataNoPermission.child.map(zone => {
              if (zone.id == parkId && zone.child) {
                zone.child.map(floor => {
                  if (!hasFindFloor && floor.id == record.zoneId) {
                    hasFindFloor = true;
                    zoneName += ` ${floor.name}`;
                  }
                });
              }
            });
          }

          return <span>{zoneName}</span>;
        }
      },
      {
        title: intl.formatMessage({ id: 'device_manage_operate' }),
        dataIndex: 'operation',
        key: 'operation',
        render: (text, record) => {
          return (
            <div className="user-operate">
              <span
                className="operate-item"
                onClick={() => {
                  //寻找parkId
                  let parkId = '';
                  if (record.zoneId) {
                    allAreaDataNoPermission.child &&
                      allAreaDataNoPermission.child.map(a => {
                        if (
                          a.child &&
                          a.child.some(c => c.id == record.zoneId)
                        ) {
                          parkId = a.id;
                        }
                      });
                  } else {
                    parkId = record.parkId ? record.parkId : '';
                  }
                  let floorData = [];
                  if (
                    allAreaDataNoPermission &&
                    allAreaDataNoPermission.child
                  ) {
                    allAreaDataNoPermission.child.map(zone => {
                      if (zone.id == parkId && zone.child) {
                        floorData = zone.child;
                      }
                    });
                  }
                  this.setState({
                    deviceInfo: record,
                    zoneId: record.zoneId + '',
                    parkId: parkId + '',
                    floorData
                  });
                  this.showModal(record);
                }}
              >
                <FormattedMessage id="device_manage_edit" />
              </span>
              <span className="operate-split">|</span>
              <span
                className="operate-item"
                onClick={() => {
                  Modal.confirm({
                    content: intl.formatMessage({
                      id: 'device_manage_confirm_delete'
                    }),
                    onOk: () => {
                      this.delete(record.id);
                    }
                  });
                }}
              >
                <FormattedMessage id="device_manage_delete" />
              </span>
            </div>
          );
        }
      }
    ];
    return (
      <div className="item-tab">
        <Table
          rowKey={r => r.id}
          columns={itemColumns}
          dataSource={deviceInfo.mobileList || []}
          pagination={{
            pageSize: 10,
            total: deviceInfo.mobileList ? deviceInfo.mobileList.length : 0
          }}
        />
      </div>
    );
  };

  stableTab = () => {
    const { deviceInfo = {}, intl, dispatch } = this.props;
    const itemColumns = [
      {
        title: intl.formatMessage({ id: 'device_manage_device_name_cn' }),
        dataIndex: 'name',
        width: '25%',
        key: 'name'
      },
      {
        title: intl.formatMessage({ id: 'device_manage_device_name_en' }),
        dataIndex: 'nameEn',
        width: '25%',
        key: 'nameEn'
      },
      {
        title: intl.formatMessage({ id: 'device_manage_operate' }),
        dataIndex: 'operation',
        width: '10%',
        key: 'operation',
        render: (text, record) => {
          return (
            <div className="user-operate">
              <span
                className="operate-item"
                onClick={() => {
                  dispatch({ type: 'account/deviceBindRooms', deviceId: record.id}).then(()=>{
                    this.setState({stableInfo: record});
                    this.showModal(record);
                  })
                }}
              >
                <FormattedMessage id="device_manage_edit" />
              </span>
              <span className="operate-split">|</span>
              <span
                className="operate-item"
                onClick={() => {
                  Modal.confirm({
                    content: intl.formatMessage({
                      id: 'device_manage_confirm_delete'
                    }),
                    onOk: () => {
                      this.delete(record.id);
                    },
                    onCancel: () => {
                      dispatch({
                        type: 'account/update',
                        payload: { bindRooms: '' }
                      })
                    }
                  });
                  dispatch({ type: 'account/deviceBindRooms', deviceId: record.id});
                }}
              >
                <FormattedMessage id="device_manage_delete" />
              </span>
            </div>
          );
        }
      }
    ];
    return (
      <div className="item-tab">
        <Table
          rowKey={r => r.id}
          columns={itemColumns}
          dataSource={deviceInfo.fixedList || []}
          pagination={{
            pageSize: 10,
            total: deviceInfo.fixedList ? deviceInfo.fixedList.length : 0
          }}
        />
      </div>
    );
  };

  itemModal = () => {
    const { allAreaDataNoPermission } = this.props;
    return (
      <div className="service-manage-modal device_manage">
        <div className="manage-row">
          <span className="prefix-title">
            <span
              style={{ color: 'red', fontSize: '14px', marginRight: '5px' }}
            >
              *
            </span>
            <FormattedMessage id="device_manage_device_name" /> :{' '}
          </span>
          <Input
            value={this.state.deviceInfo.name}
            maxLength="15"
            onChange={e => {
              const value = e.target.value;
              this.setState({
                deviceInfo: { ...this.state.deviceInfo, ...{ name: value } }
              });
            }}
          />
        </div>
        <div className="manage-row">
          <span className="prefix-title">
            <FormattedMessage id="device_manage_device_describe" /> :{' '}
          </span>
          <Input
            value={this.state.deviceInfo.remark}
            maxLength="200"
            onChange={e => {
              const value = e.target.value;
              this.setState({
                deviceInfo: { ...this.state.deviceInfo, ...{ remark: value } }
              });
            }}
          />
        </div>
        <div className="manage-row">
          <span className="prefix-title">
            <span
              style={{ color: 'red', fontSize: '14px', marginRight: '5px' }}
            >
              *
            </span>
            <FormattedMessage id="device_manage_device_number" /> :{' '}
          </span>
          <InputNumber
            min={0}
            value={this.state.deviceInfo.number}
            onChange={value => {
              this.setState({
                deviceInfo: { ...this.state.deviceInfo, ...{ number: value } }
              });
            }}
          />
        </div>
        <div className="manage-row">
          <span className="prefix-title">
            <span
              style={{ color: 'red', fontSize: '14px', marginRight: '5px' }}
            >
              *
            </span>
            <FormattedMessage id="device_manage_floor" /> :{' '}
          </span>
          <div style={{ width: '43%' }}>
            <Select
              placeholder={this.props.intl.formatMessage({
                id: 'device_manage_area'
              })}
              value={this.state.parkId}
              onChange={value => {
                let floorData = [];
                if (allAreaDataNoPermission && allAreaDataNoPermission.child) {
                  allAreaDataNoPermission.child.map(zone => {
                    if (zone.id == value && zone.child) {
                      floorData = zone.child;
                    }
                  });
                }
                this.setState({ floorData, parkId: value, zoneId: '' });
              }}
            >
              {allAreaDataNoPermission &&
                allAreaDataNoPermission.child &&
                allAreaDataNoPermission.child.map(zone => {
                  return (
                    <Select.Option value={`${zone.id}`} key={`${zone.id}`}>
                      {zone.name}
                    </Select.Option>
                  );
                })}
            </Select>
          </div>
          <div style={{ width: '6%' }} />
          <div style={{ width: '43%' }}>
            <Select
              placeholder={this.props.intl.formatMessage({
                id: 'device_manage_floor'
              })}
              value={
                this.state.zoneId && this.state.zoneId != '0'
                  ? this.state.zoneId
                  : ''
              }
              onChange={value => {
                this.setState({ zoneId: value });
              }}
            >
              {this.state.floorData &&
                this.state.floorData.map(fd => {
                  return (
                    <Select.Option value={`${fd.id}`} key={`${fd.id}`}>
                      {fd.name}
                    </Select.Option>
                  );
                })}
            </Select>
          </div>
        </div>
      </div>
    );
  };

  stableModal = () => {
    const { stableInfo } = this.state;
    return (
      <div className="service-manage-modal device_manage">
        <div className="manage-row">
          <span className="prefix-title">
            <span
              style={{ color: 'red', fontSize: '14px', marginRight: '5px' }}
            >
              *
            </span>
            <FormattedMessage id="device_manage_device_name_cn" /> :{' '}
          </span>
          <Input
            value={stableInfo.name}
            maxLength="100"
            onChange={e => {
              const value = e.target.value;
              this.setState({
                stableInfo: { ...stableInfo, ...{ name: value } }
              });
            }}
          />
        </div>
        <div className="manage-row">
          <span className="prefix-title">
            <span
              style={{ color: 'red', fontSize: '14px', marginRight: '5px' }}
            >
              *
            </span>
            <FormattedMessage id="device_manage_device_name_en" /> :{' '}
          </span>
          <Input
            value={stableInfo.nameEn}
            maxLength="100"
            onChange={e => {
              const value = e.target.value;
              this.setState({
                stableInfo: { ...stableInfo, ...{ nameEn: value } }
              });
            }}
          />
        </div>
      </div>
    );
  };

  delete = deviceId => {
    const { dispatch, intl } = this.props;
    const promise = new Promise((resolve, reject) => {
      dispatch({ type: 'account/deleteDevice', deviceId, resolve, reject });
    });
    promise.then(
      () => {
        Modal.success({
          content: intl.formatMessage({
            id: 'device_manage_warning_delete_success'
          })
        });
        dispatch({ type: 'account/getAllDeviceInfo' });
        dispatch({ type: 'account/update', payload: { bindRooms: '' }});
      },
      msg => {
        Modal.error({ content: msg });
      }
    );
  };

  checkData = (deviceInfo, stableInfo, activeKey) => {
    const { intl } = this.props;
    if (activeKey === MOBILE_TAB) {
      if (!deviceInfo.name) {
        Modal.warning({
          content: intl.formatMessage({ id: 'device_manage_warning_empty_name' })
        });
        return false;
      }
      if (deviceInfo.number == null || deviceInfo.number === '') {
        Modal.warning({
          content: intl.formatMessage({
            id: 'device_manage_warning_empty_number'
          })
        });
        return false;
      }
      if (!deviceInfo.zoneId || deviceInfo.zoneId == 0) {
        Modal.warning({
          content: intl.formatMessage({ id: 'device_manage_warning_empty_floor' })
        });
        return false;
      }
    } else if (activeKey === STABLE_TAB) {
      if (!stableInfo.name) {
        Modal.warning({
          content: intl.formatMessage({ id: 'device_manage_warning_empty_name_cn' })
        });
        return false;
      }
      if (!stableInfo.nameEn) {
        Modal.warning({
          content: intl.formatMessage({ id: 'device_manage_warning_empty_name_en' })
        });
        return false;
      }
    }
    return true;
  };

  submit = () => {
    const { dispatch, intl } = this.props;
    //检查数据
    const { deviceInfo = {}, stableInfo = {}, activeKey } = this.state;
    deviceInfo.zoneId = this.state.zoneId;
    if (!this.checkData(deviceInfo, stableInfo, activeKey)) {
      return false;
    }
    const promise = new Promise((resolve, reject) => {
      dispatch({
        type: 'account/saveDevice',
        deviceInfo: activeKey === MOBILE_TAB ? deviceInfo : stableInfo ,
        resolve,
        reject
      });
    });
    promise.then(
      () => {
        this.closeModal();
        dispatch({ type: 'account/getAllDeviceInfo' });
        if (deviceInfo.id && deviceInfo.id > 0) {
          Modal.success({
            content: intl.formatMessage({id: 'device_manage_warning_edit_success'})
          });
        } else {
          Modal.success({
            content: intl.formatMessage({id: 'device_manage_warning_save_success'})
          });
        }
      },
      msg => {
        Modal.error({ content: msg });
      }
    );
  };

  showModal = deviceEditObj => {
    this.props.dispatch({
      type: 'account/update',
      payload: { deviceModal: true, deviceEditObj: deviceEditObj }
    });
  };

  closeModal = () => {
    this.props.dispatch({
      type: 'account/update',
      payload: { deviceModal: false, bindRooms: '' }
    });
  };
}

export default DeviceManagement;



// WEBPACK FOOTER //
// ./src/components/account/DeviceManagement.js